<template>
  <div>
    <div class='h100vh-158 w100vw-284 h-scroll' id='noRealQuery'>
      <ejs-grid ref="noRealQueryList" :allowPaging="false" :dataSource="dataSourceOfNoRealQueryList" :columns='columnsNoRealQueryList' :height="screenHeight"></ejs-grid>
    </div>
    <div>
      <ejs-pager ref='pagerOfQueryList' @click='updateQueryList()' :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoRealQueryListPage',
  props: [
    'dataOfNoQueryList',
    'measureObjSelectedAttrs',
    'checkedNodesOfMeasureTree',
    'meterPeriod'
  ],
  data() {
    return {
      dataSourceOfNoRealQueryList: [{}],
      columnsNoRealQueryList: [],
      screenHeight: 'calc(100vh - 197px)',
      page: {
        currentPage: 1,
        pageSize: 25,
        totalRecordsCount: 0,
        pageCount: 10
      },
    };
  },
  methods: {
    updateQueryList(){
      const This = this;
      this.$emit('pageClick', This.$refs.pagerOfQueryList.ej2Instances.currentPage);
    }
  },
  watch: {
    // 监听查询数据表的动态数据
    dataOfNoQueryList(msg) {
      this.dataSourceOfNoRealQueryList = [];
      this.dataSourceOfNoRealQueryList = msg;
      const columnsCacheOfSpeCommonAttr = []; // 特殊公共字段缓存
      const columnsCacheOfCounters = []; // counter字段缓存
      const columnsCache = []; // 所有字段缓存



      // 通用公共字段缓存
      const columnsCacheOfOrdCommonAttr = [
        {
          field: 'ne_name',
          headerText: this.$t('Pm.resource_name'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'ne_type_id',
          headerText: this.$t('Pm.ne_type_id'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'ne_id',
          headerText: this.$t('Pm.ne_id'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'statistic_cycle',
          headerText: this.$t('Pm.statistic_cycle'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'start_time',
          headerText: this.$t('Pm.start_time'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'end_time',
          headerText: this.$t('Pm.end_time'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'Intodb_time',
          headerText: this.$t('Pm.Intodb_time'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        },
        {
          field: 'data_bilievable',
          headerText: this.$t('Pm.data_bilievable'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100
        }
      ]

      // 通用公共字段 field 缓存,用于通用公共字段和特殊公共字段筛选
      const columnsCacheOfOrdCommonAttrField = ['ne_name','ne_type_id','ne_id','statistic_cycle','start_time','end_time','Intodb_time','data_bilievable']

      for (const i in msg[0]) {
        // 存放并配置公共字段信息到公共字段缓存
        if (i.indexOf('C000') == -1 && i.indexOf('K000') == -1 && i.indexOf('U1') == -1 && columnsCacheOfOrdCommonAttrField.indexOf(i) == -1) {
          columnsCacheOfSpeCommonAttr.push({
            field: i,
            headerText: this.$t(`Pm.${i}`),
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 100
          });
        }
      }

      // 存放并配置counter字段信息到counter字段缓存
      for (let i = 0; i < this.checkedNodesOfMeasureTree.length; i++) {
        if (this.checkedNodesOfMeasureTree[i].id.indexOf('_U') != -1  || this.checkedNodesOfMeasureTree[i].id.indexOf('_C') != -1 || this.checkedNodesOfMeasureTree[i].id.indexOf('_K') != -1){

          const fieldKey = this.checkedNodesOfMeasureTree[i].id.split('_')[2]
          for (let j = 0; j < this.measureObjSelectedAttrs.length; j++) {
            if (this.measureObjSelectedAttrs[j].kpiCode == fieldKey) {
              if(fieldKey.indexOf('U') == -1) {
                columnsCacheOfCounters.push({
                  field: fieldKey,
                  headerText: (this._i18n.locale === 'zh') ? `${this.measureObjSelectedAttrs[j].kpiNameCn}(${this.measureObjSelectedAttrs[j].kpiUnitCn})` : `${this.measureObjSelectedAttrs[j].kpiNameEn}(${this.measureObjSelectedAttrs[j].kpiUnitEn})`,
                  textAlign: 'Center',
                  clipMode: 'EllipsisWithTooltip',
                  width: 100,
                  valueAccessor: function valueAccessor (field,data){
                    return data[field] == undefined || data[field] == null || data[field] == '' ? '—' : data[field];
                  }
                });
              } else if (this.meterPeriod == 2) { // 自定指标，kpiNameCn 字段存的是指标名称，kpiNameEn 字段存的是指标描述，比较反人类
                columnsCacheOfCounters.push({
                  field: fieldKey,
                  headerText: (this._i18n.locale === 'zh') ? `${this.measureObjSelectedAttrs[j].kpiNameCn}(${this.measureObjSelectedAttrs[j].kpiUnitCn})` : `${this.measureObjSelectedAttrs[j].kpiNameCn}(${this.measureObjSelectedAttrs[j].kpiUnitEn})`,
                  textAlign: 'Center',
                  clipMode: 'EllipsisWithTooltip',
                  width: 100,
                  valueAccessor: function valueAccessor (field,data){
                    return data[field] == undefined || data[field] == null || data[field] == '' ? '—' : data[field];
                  }
                });
              }
            }
          }
        }
      }

      // 先存放公共字段信息到总缓存，再存放counter字段信息到总缓存，保证columns正确顺序
      for (let k = 0; k < columnsCacheOfOrdCommonAttr.length; k++) {
        columnsCache.push(columnsCacheOfOrdCommonAttr[k]);
      }

      for (let k = 0; k < columnsCacheOfSpeCommonAttr.length; k++) {
        columnsCache.push(columnsCacheOfSpeCommonAttr[k]);
      }
      for (let k = 0; k < columnsCacheOfCounters.length; k++) {
        columnsCache.push(columnsCacheOfCounters[k]);
      }
      this.columnsNoRealQueryList = columnsCache;
    }
  }
};
</script>

<style>
  #noRealQuery .e-gridcontent.e-lib.e-droppable{
    height: calc(100vh - 197px) !important;
  }
</style>
